<template>
  <div class="procedures-editor-header">
    <icon size="16" type="md-document" class="ms-help" />
    <span style="margin-left: 4px" class="ms-help">
      {{ `${procedure.id ? "Редактирование" : "Создание"} запроса материалов` }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['procedure']
}
</script>

<style lang="less">
.procedure-editor-header {
  display: flex;
  align-items: center;
}
</style>
